import { Component, Inject, OnDestroy, OnInit , Input, Output, EventEmitter} from '@angular/core';
import { Store } from '@src/store';
// import { projectActions } from "../../../../store/reducers/projectReducer";


@Component({
    selector: 'schemas-env-type-rotate',
    template: require('./environmentTypeRotator.html'),
    styles: [require('./_environmentTypeRotator.scss')]
})

export class EnvTypeRotateComponent implements OnInit , OnDestroy {

       @Input() public projectData;
       @Output() onRotateLeft = new EventEmitter<any>();
       @Output() onRotateRight = new EventEmitter<any>();
       @Output() close = new EventEmitter<any>();
       
     public _currEnvTypeIndex:any
     public currEnvironmentType:any
     public prevEnvironmentType:any
     public nextEnvironmentType:any
     public canRotateLeft:any
     public canRotateRight:boolean


    constructor(@Inject('$scope') public $scope: any, public store : Store, @Inject('$state') public state: any,@Inject('$stateParams') public $stateParams: any) {

    }

    // this.onChangeHost.emit({ hostselected: this.selectedHost,
    //     unmangeSchemasByHostList: this.unmangeSchemasByHostList })

    ngOnInit() {
        this.$scope.$watch(() => this.currEnvironmentType, () => {
            this.canRotateLeftValidate();
            this.canRotateRightValidate();
        }, true);
    }

    @Input() set currEnvTypeIndex(value){
        this._currEnvTypeIndex = value;
        // let prevVal = value - 1;
        // let nextVal = value + 1;

        let prevVal = 0;
        if(value-1 < 0)
            prevVal = this.selectedEnvTypes.length - 1 + value ;
        else
            prevVal = (value - 1) % this.selectedEnvTypes.length;
        let nextVal = (value + 1) % this.selectedEnvTypes.length;



        this.currEnvironmentType = this.selectedEnvTypes[value];
        this.prevEnvironmentType = this.selectedEnvTypes[prevVal];
        this.nextEnvironmentType = this.selectedEnvTypes[nextVal];
    }


    get currEnvTypeIndex(){
        return this._currEnvTypeIndex;
    }

    get selectedEnvTypes () {
        return this.projectData
            ? this.projectData.environmentTypes.filter(item => item.selected)
            : [];
    }

    onClose(){
        this.close.emit()
    }

    canRotateLeftValidate () {
        this.canRotateLeft = true;
        if (this.currEnvironmentType!= null && this.currEnvironmentType &&  this.currEnvironmentType.isRMSource) {
            if(this.currEnvironmentType.environments.length > 0){
                if (this.currEnvironmentType.environments[0].schemas == null || (this.currEnvironmentType.environments[0].schemas.length == 0 && this.currEnvironmentType.environments[0].schemas4UIView.length == 0)) {
                    this.canRotateLeft = false;
                }
            }
        }
    }

    RotateRight(){
        this.onRotateRight.emit()
    }

    RotateLeft(){
        this.onRotateLeft.emit()
    }

    canRotateRightValidate () {
        this.canRotateRight = true;
        if (this.currEnvironmentType!= null && this.currEnvironmentType && this.currEnvironmentType.isRMSource){
            if(this.currEnvironmentType.environments.length > 0){
                if (this.currEnvironmentType.environments[0].schemas == null || (this.currEnvironmentType.environments[0].schemas.length == 0 && this.currEnvironmentType.environments[0].schemas4UIView.length == 0)){
                    this.canRotateRight = false;
                }
            }
        }
        //this.canRotateRight =  this.canRotateRight && (this.currEnvTypeIndex < this.selectedEnvTypes.length -1);
    }

    ngOnDestroy(): void {}


    
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/projectWizard/assignSchemas-ang7/environmentTypeRotator/environmentTypeRotator.ts